import Client from '../../models/client'
import { ClientAction } from '../actions/client'

const initialState = {
  isFetching: false,
  client: null,
  target_cv_num: 0,
  line_message: '',
  coming_name: false,
  coming_mail: false,
  coming_tel: false,
  coming_other: false,
  coming_address: false,
}

interface Props {
  isFetching: boolean
  client: Client | null
  target_cv_num: number
  line_message: string
  coming_name: boolean
  coming_mail: boolean
  coming_tel: boolean
  coming_other: boolean
  coming_address: boolean
}

const reducer = (state: Props = initialState, action: ClientAction): Props => {
  switch (action.type) {
    case 'REQUEST_CLIENT': {
      return {
        ...state,
        isFetching: true,
      }
    }
    case 'RECIEVE_CLIENT': {
      return {
        ...state,
        client: action.client,
        isFetching: false,
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
